import { useRef, useState, useEffect } from 'react';

export default (container, content, duration = 400) => {
  const animation = useRef(null);
  const open = useRef(false);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    function onResize() {
      setHeight(content.current.offsetHeight);
    }

    window.addEventListener('resize', onResize);
    onResize();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    const frames = [{ height: '0px' }, { height: `${height}px` }];
    const options = {
      duration,
      easing: 'ease-out',
      fill: 'both',
    };

    if (height) {
      animation.current = container.current.animate(frames, options);
      animation.current.currentTime = 0;
      animation.current.pause();

      if (open.current) {
        animation.current.finish();
      }
    }

    return () => {
      if (animation.current) {
        animation.current.cancel();
      }
    };
  }, [height]);

  return {
    open: () => {
      if (animation.current) {
        if (animation.current.currentTime === 0) {
          animation.current.addEventListener(
            'finish',
            () => {
              open.current = true;
            },
            { once: true }
          );

          animation.current.effect.updateTiming({
            easing: 'ease-out',
          });

          animation.current.playbackRate = 1;
          animation.current.play();
        }
      }
    },

    close: () => {
      if (animation.current) {
        if (animation.current.currentTime === duration) {
          animation.current.addEventListener(
            'finish',
            () => {
              animation.current.pause();
              animation.current.playbackRate = 1;
              animation.current.currentTime = 0;
              open.current = false;
            },
            { once: true }
          );

          animation.current.effect.updateTiming({
            easing: 'ease-in',
          });

          animation.current.playbackRate = -1;
          animation.current.play();
        }
      }
    },
  };
};
